import { Box } from '@mui/material';
import { FC, ReactNode, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { Header } from './';

interface IPage {
  children: ReactNode;
  title: string;
}

/**
 * Controls both the <Footer /> text display and the window title.
 */
const CLIENT_NAME = 'Franklin St.';

/**
 * Application-wide basis for any new page/vertical.
 */
export const Page: FC<IPage> = ({ children, title }) => {
  const { pathname } = useLocation();
  const headerEl = useRef<HTMLDivElement | null>(null);

  // Set the window/tab title.
  useEffect(() => {
    document.title = `${title} | ${CLIENT_NAME}`;
  }, [pathname, title]);

  return (
    <>
      <div
        id="header-container"
        ref={headerEl}
        style={{
          width: '100%',
          position: 'sticky',
          top: 0,
          zIndex: 10,
          backgroundColor: '#ffffff',
        }}
      >
        <Header title={title} />
      </div>
      <Box
        display="flex"
        flexDirection="column"
        sx={theme => ({
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          paddingLeft: theme.spacing(1.5),
          paddingRight: theme.spacing(1.5),
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
          [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1),
          },
          width: 'calc(100% - ' + theme.spacing(4) + ')',
          boxShadow: '0px 10px 20px -5px #00000040',
          minHeight: '80vh',
        })}
      >
        {children}
      </Box>
    </>
  );
};
